module.exports = __webpack_public_path__ + "b06b339d2834ed074fb8290ab2faac62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maxbonus.png
// module id = 748
// module chunks = 0